import React, { Component } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Flexbox } from './Styles';
import Facebook from './images/facebook.png';
import Twitter from './images/twitter.png';
import { ShareButtons } from 'react-share';
const { FacebookShareButton, TwitterShareButton } = ShareButtons;

const styles = StyleSheet.create({
  facebookButton: {
    height: 50,
    width: 50,
    margin: 10,
    backgroundImage: `url(${Facebook})`,
    cursor: 'pointer'
  },
  twitterButton: {
    height: 50,
    width: 50,
    margin: 10,
    backgroundImage: `url(${Twitter})`,
    cursor: 'pointer'
  }
});

class ShareIcons extends Component {
  render() {
    return(
      <div className={css(Flexbox.row)}>
        <FacebookShareButton url={window.location.href} title={this.props.title} description={this.props.description} >
          <div className={css(styles.facebookButton)}></div>
        </FacebookShareButton>
        <TwitterShareButton url={window.location.href} title={this.props.title}>
          <div className={css(styles.twitterButton)}></div>
        </TwitterShareButton>
      </div>
    );
  }
}

export default ShareIcons;



// WEBPACK FOOTER //
// ./src/ShareIcons.js